module.exports = __webpack_public_path__ + "static/media/quinscape.a4ec684e.svg";